import type { TooltipProps } from 'antd';
import { Tooltip } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';

import { humanize } from 'utils/global';

type FBTooltipProps = Omit<TooltipProps, 'title'> & {
  dataCy?: string;
  loading?: boolean;
} & ({
    translate: true;
    title?: string;
} | ({
    translate?: false;
    title?: string | React.ReactNode;
}))

const FBTooltip = ({ children, title, translate, loading, dataCy, ...rest }: FBTooltipProps) => {
  const intl = useIntl();

  return (
    <Tooltip
      title={
        title ? (
          <span data-cy={dataCy}>
            {loading && (
              <div className="text-center">
                <span className="fb-icon-spin fb-icon--spin text-lg" />
              </div>
            )}
            {!loading && (translate ? intl.formatMessage({ id: String(title), defaultMessage: humanize(String(title)) }) : title)}
          </span>
        ) : undefined
      }
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export default FBTooltip;
